import { createStore } from 'effector'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const $isClient = createStore(typeof document !== 'undefined', {
    serialize: 'ignore'
})
